import { FormEvent } from "react";
import { createClassNames } from "src/utils/classNames";

export const CRFClassNameGenerator = createClassNames("SoftCreditPullForm");

export const setCustomErrorMessage = (message: string) => (e: FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const el = e.currentTarget as HTMLInputElement | HTMLSelectElement;
    el.setCustomValidity(message);
};

export const resetCustomErrorMessage = (e: FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const el = e.currentTarget as HTMLInputElement | HTMLSelectElement;
    el.setCustomValidity("");
};
